export enum RoleTypeEnum {
  RS_SUPPORT = 'GG-TH-GIFTCARD-RSSupport',
  RS_ADMIN = 'GG-TH-GIFTCARD-RSAdmin',
  RS_WL3 = 'GG-TH-GIFTCARD-RSWL3',
  ACCOUNT_1 = 'GG-TH-GIFTCARD-Account1',
  ACCOUNT_2 = 'GG-TH-GIFTCARD-Account2',
  IT_ADMIN = 'GG-TH-GIFTCARD-ITAdmin',
}
